export function getBaseUrl(url) {
  const parts = url.split("/");

  parts.pop();

  return parts.join("/");
}
